<!--历史记录-->
<template>

  <div>
    <div class="search-content">

      <el-col :span="24" class="toobar">
        <el-col :span="18">
          <!--<el-date-picker :clearable="true"-->
          <!--v-model="accdate" :required="true"-->
          <!--type="date"-->
          <!--style="width:150px;"-->
          <!--value-format="yyyy-MM-dd"-->
          <!--placeholder="选择日期">-->
          <!--</el-date-picker>-->
          <el-date-picker
            :clearable="true" size="mini"
            v-model="searchdatevalue"
            type="daterange" :value-format="'yyyy-MM-dd'"
            align="left" :unlink-panels="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 240px"
          >
          </el-date-picker>
          <el-input placeholder="请输入摘要" v-model="summary" clearable size="mini"
                    style="width:130px;">
          </el-input>
          <el-input placeholder="请输入凭证号" v-model="auxiliaryserial" clearable v-if="!simpleedit" style="width:145px;" size="mini">
          </el-input>
          <el-select v-model="buyhetongserial" placeholder="请选择收款银行" style="width: 145px" clearable filterable size="mini">
            <el-option
              v-for="item in buyhetongseriallist"
              :key="item.value"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
          <el-input placeholder="请输入回款方式" v-model="auxiliary" clearable v-if="!simpleedit" size="mini"
                    style="width:145px;">
          </el-input>
          <el-input placeholder="请输入汇款公司" v-model="buyhetongname" clearable v-if="!simpleedit" size="mini"
                    style="width:145px;">
          </el-input>
          <el-input placeholder="起始金额" v-model="begindebit" clearable size="mini"
                    style="width:110px;">
          </el-input>
          -
          <el-input placeholder="结束金额" v-model="enddebit" clearable size="mini"
                    style="width:110px;">
          </el-input>
          <el-select v-model="independentserial" filterable style="width:145px;" v-if="!simpleedit" size="mini">
            <el-option v-for="item1 in idd"
                       :key="item1.serialnum"
                       :label="item1.dname"
                       :value="item1.serialnum">
            </el-option>
          </el-select>
          <el-select v-model="hetongserial" filterable style="width:110px;" v-if="parames.length>0" size="mini">
            <el-option v-for="item in parames" :key="item.value"
                       :label="item.name"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
          <el-button type="primary" icon="el-icon-download" @click="excelPort" size="mini">导出</el-button>
        </el-col>
      </el-col>
    </div>
    <el-col :span="24">
        <el-table
          :data="tableData"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号" fixed
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
            </template>
          </el-table-column>
          <el-table-column
            prop="accdate"
            label="日期"
            align="center"
            header-align="center"
            width="95">
            <template slot-scope="scope">
              {{(scope.row.accdate||"").substr(0,10)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="setofbooks"
            label="账套" width="80" :show-overflow-tooltip="true"
            align="left"
            header-align="center">
            <template slot-scope="scope">
              {{getSetofwooks(scope.row.hetongserial)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="customerserial" v-if="!simpleedit"
            label="客户编码"
            align="left"
            header-align="center"
            width="100" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="customername"
            label="客户名称"
            align="left"
            header-align="center"  width="250" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="serveuname" v-if="!simpleedit"
            label="业务员"
            align="center"
            header-align="center"  width="100">
          </el-table-column>
          <el-table-column
            prop="servedname" v-if="!simpleedit"
            label="服务部门"
            align="center"
            header-align="center" width="100" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="accountname" v-if="!simpleedit"
            label="科目"
            align="center"
            header-align="center"
            width="100">
            <template slot-scope="scope">
              {{getAccName(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="debit"
            label="金额"
            align="right"
            header-align="center"
            width="100"
          >
            <template slot-scope="scope">
              {{scope.row.debit|numeric(2)}}{{scope.row.credit|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="buyhetongserial"
            label="收款银行"
            align="left"
            header-align="center" :show-overflow-tooltip="true"
            width="100">
          </el-table-column>
          <el-table-column
            prop="applyby"
            label="录入人"
            align="center"
            header-align="center"
            width="95">
            <template slot-scope="scope">
              {{scope.row.applyby}}
            </template>
          </el-table-column>
          <el-table-column
            prop="insertdate"
            label="录入时间"
            align="center"
            header-align="center"
            width="165">
            <template slot-scope="scope">
              {{formatInsertDate(scope.row.insertdate)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="summary" width="200" v-if="!simpleedit"
            label="摘要"
            align="left"
            header-align="center" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="summary" v-if="simpleedit"
            label="摘要"
            align="left"
            header-align="center" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="auxiliaryserial" v-if="!simpleedit"
            label="凭证号"
            align="center"
            header-align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="auxiliary" v-if="!simpleedit"
            label="回款方式"
            align="center"
            header-align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="buyhetongname" v-if="!simpleedit"
            label="汇款公司"
            align="left"
            header-align="center" :show-overflow-tooltip="true"
            width="140">
          </el-table-column>
          <el-table-column
            prop="billserial" v-if="!simpleedit"
            label="税号"
            align="left"
            header-align="center" :show-overflow-tooltip="true"
            width="150">
          </el-table-column>
          <el-table-column
            prop="remark" width="200" v-if="!simpleedit"
            label="备注"
            align="left"
            header-align="center" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="操作" align="center" width="80" fixed="right" v-if="!simpleedit">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看
              </el-button>
              <!--<el-button-->
              <!--size="mini" v-if="scope.row.canedit"-->
              <!--type="danger"-->
              <!--@click="handleDelete(scope.$index, scope.row)">删除-->
              <!--</el-button>-->
            </template>
          </el-table-column>
        </el-table>
    </el-col>
    <el-col :span="24">
      <el-col :span="18">
    <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
      </el-col>
      <el-col :span="6">
   合计： {{totalmoney}}
      </el-col>
    </el-col>
  </div>
</template>

<script>

  import {getList} from '@/api/voucher/accountvoucherdetail'
  import {getListData} from '@/api/set/PriceandKd';
  import {independentDept} from '@/api/set/dept';

  export default {
    inject: ["initDistributionEdit", "initReceivablesEdit", "getAccountName"],
    name: 'DetailList',
    data() {
      return {
        bindname: '',
        showname: '',
        parames: [],
        totalmoney: 0,
        msg: 'Welcome to Your Vue.js App',
        loading: true,
        tableData: [],
        customerserial: '',//客户编码
        hetongserial: '',
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        summary: '',//摘要
        accdate: '',//日期
        auxiliary: '',//回款方式
        buyhetongname: '',//汇款公司
        buyhetongserial: '',//收款银行
        auxiliaryserial: '',//凭证号
        begindebit: '',//起始金额
        enddebit: '',//结束金额
        searchdatevalue: [],
        buyhetongseriallist: [],//收款银行选择项
        idd: [],//服务中心数组
        hasLoad: false,
        userInfoModel: {},//缓存数据
        independentserial: '',//根据登陆人默认服务中心
      }
    },
    props: {
      accountnames: {
        defalut: ""
      },
      accountcode: {
        defalut: "1122"
      },
      needmounted: false,
      simpleedit: false
    },
    methods: {
      getSetofwooks(value) {
        for (let i in this.parames) {
          if (this.parames[i].value == value)
            return this.parames[i].name;
        }
        return '';
      },
      getAccName(row) {
        return row.accountname
      },
      //获取服务中心
      independentDept() {
        if (this.hasLoad) return;
        this.hasLoad = true;
        this.buyhetongserials();
        independentDept().then(response => {
          this.idd = response.data.obj
          if (this.userInfoModel.independentserial != "" && (this.roletype == "order" || this.roletype == 'customerservice')) {
            //此时是经销商账户登录，且是订单或者客服菜单进入，  需要在服务部门下拉框增加  总部 选项
            this.idd.unshift({serialnum: "", dname: this.userInfoModel.tenantname})
          }
          this.idd.unshift({serialnum: "all", dname: "全部"})
        })
      },
      //收款银行
      buyhetongserials() {
        getListData({
            offset: 0,
            limit: 10000,
            paraname: '收款银行',
          }
        ).then(response => {
          var tabledata = response.data.obj
          for (let i = 0; i < tabledata.length; i++) {
            var obj = {name: '', value: ''}
            obj.name = tabledata[i].name
            obj.value = tabledata[i].unitguid
            this.buyhetongseriallist.push(obj)
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      //导出
      excelPort() {
        this.loadData(true);
      },
      handleEdit(index, row) {
        if (row.accountname.indexOf('销售支持') > -1) {
          this.initReceivablesEdit(row.unitguid, '销售支持')
        } else if (row.accountname.indexOf('调整') > -1) {
          this.initReceivablesEdit(row.unitguid, '调整')
        } else if (row.accountname.indexOf('已收现销') > -1 || row.accountname.indexOf('预收铺货款') > -1) {
          this.initReceivablesEdit(row.unitguid, '收款')
        } else if (row.accountname.indexOf('铺货') > -1) {
          this.initDistributionEdit(row.unitguid)
        }
      },
      show(customerserial, accountname) {
        console.log('......................')
        this.initform()
        this.customerserial = customerserial;
        this.bindname = accountname

        if (accountname && accountname.indexOf('销售支持') > -1) {
          this.showname = "销售支持";
        } else if (accountname && accountname.indexOf('调整') > -1) {
          this.showname = "调整";
        } else if (accountname && (accountname.indexOf('已收现销') > -1 || accountname.indexOf('预收铺货款') > -1)) {
          this.showname = "收款";
        } else {
          this.showname = "铺货";
        }
        this.bindGrid()
        this.independentDept()
      },
      bindGrid() {
        this.loadData(false);
      },
      loadData(isPrint) {
        var accname = this.accountnames;
        if (this.bindname && this.bindname != '' && this.bindname != '铺货')
          accname = this.bindname;
        else if (this.accountnames == "") {
          accname = this.getAccountName()
        }
        if (accname == '已收现销')
          accname = '已收现销,预收铺货款'

        if (!this.accountcode) {
          this.accountcode = '1122'
        }
        var row = {
          customerserial: this.customerserial,
          accountnames: accname,
          accountcode: this.accountcode,
          skimaccvoucherguid: "",
          yearflag: '',//this.yearflag,
          monthflag: '',// this.monthflag,
          sort: "accdate",
          order: "desc",
          begintime: (this.searchdatevalue&&this.searchdatevalue.length > 0) ? this.searchdatevalue[0] :'' ,
          endtime: (this.searchdatevalue&&this.searchdatevalue.length > 0) ? this.searchdatevalue[1] :'',
          summary: this.summary,
          buyhetongserial: this.buyhetongserial,
          auxiliaryserial: this.auxiliaryserial,
          hetongserial: this.hetongserial,
          auxiliary: this.auxiliary,
          buyhetongname: this.buyhetongname,
          begindebit: this.begindebit,
          enddebit: this.enddebit,
          independentserial: this.independentserial,
          offset: isPrint ? null : ((this.pagination.currentPage - 1) * this.pagination.pageSize),
          limit: isPrint ? null : this.pagination.pageSize
        };
        if (this.simpleedit) {
          row.applybyguid = this.userInfoModel.uguid;
        }
        getList(row).then(response => {
          if (isPrint) {//触发打印操作
            let data = []
            for (let i in response.data.obj) {
              data.push(Object.assign({}, response.data.obj[i]))
            }
            for (let i in data) {
              data[i].accdate = data[i].accdate.substr(0, 10);
              if (data[i].credit && data[i].credit != 0) {
                data[i].debit = data[i].credit;
              }

              data[i].setofbooks = this.getSetofwooks(data[i].hetongserial);
            }
            var date = new Date();
            var y = 1900 + date.getYear();
            var m = "0" + (date.getMonth() + 1);
            var d = "0" + date.getDate();
            let header1 = ["日期", "录入人", "录入时间", "账套", "客户编码", "客户名称", "省","市","县","业务员", "服务部门", "科目", "摘要", "金额", "凭证号", "收款银行", "回款方式", "汇款公司", "税号", "备注"]
            let column1 = ["accdate", "applyby", "insertdate", "setofbooks", "customerserial", "customername", "province","city","county","serveuname", "servedname", "accountname", "summary", "debit", "auxiliaryserial", "buyhetongserial", "auxiliary", "buyhetongname", "billserial", "remark"]
            var name = this.showname + "记录" + y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length)

            this.$exportExcel(header1, column1, data, name)
          } else {
            this.tableData = response.data.obj.rows
            this.pagination.total = response.data.obj.total;
            this.totalmoney = response.data.debit + response.data.credit;
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      initform() {
        this.tableData = []
        this.customerserial = ''
        this.accdate = ''
        this.summary = ''
        this.begindebit = ''
        this.enddebit = ''
        this.auxiliary = ''
        this.auxiliaryserial = ''
        this.buyhetongname = ''
        this.buyhetongserial = ''
        this.independentserial = "all";
      },
      padZero(num){
        if(num<=9){
          return '0'+num;
        }
        return num;
      },
      formatInsertDate(date) {
        if (!date) return '';
        var d = new Date(date);
        if (isNaN(d.getTime())) return date;
        return d.getFullYear() + '-' + this.padZero(d.getMonth() + 1) + '-' + this.padZero(d.getDate()) + ' ' + this.padZero(d.getHours()) + ':' + this.padZero(d.getMinutes()) + ':' + this.padZero(d.getSeconds());
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      var param = this.userInfoModel.setofbooks;
      if (param) {
        this.parames = JSON.parse(param);
        this.parames.unshift({value: "", name: "全部账套"})
        this.hetongserial = "";
      }
      var nowD = new Date();
      if (this.simpleedit) {
        nowD = nowD.getFullYear() + '-' + this.padZero(nowD.getMonth() + 1) + '-' + this.padZero(nowD.getDate());
        this.searchdatevalue = [nowD, nowD];
      }else{
        var beginD=nowD.getMonth()==1?((nowD.getFullYear()-1)+'-12-01'):(
          nowD.getFullYear() + '-' + this.padZero(nowD.getMonth()) + '-01'
        );
        nowD = nowD.getFullYear() + '-' + this.padZero(nowD.getMonth() + 1) + '-' + this.padZero(nowD.getDate());
        this.searchdatevalue = [beginD, nowD];
      }
      this.independentserial = "all";
      this.independentDept()
      if(this.needmounted)
        this.bindGrid();
    },
    components: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/voucher/DetailList.vue